// This is for the Live Dev Environment

export const environment = {
  production: false,
  useHash: true,
  extraDebugging: true,  
  API_URL: 'https://smj-dev.fs2c.usda.gov/services/api',
  AUTH_URL: 'https://smj-dev.fs2c.usda.gov/services/auth',
  REPORT_URL: 'https://smj-dev.fs2c.usda.gov/reports',
  HOME_URL: 'https://smj-dev.fs2c.usda.gov',
  LOGIN_PORTAL: 'https://smj-dev.fs2c.usda.gov/smokejumper',
  USE_FSAPPS_NEXT_GEN: 'Y',
  FSAPPS_NXTGEN_AUTH_URL: 'https://fsappsgateway-dev.fs2c.usda.gov/oauth2'
}
